module.exports = __webpack_public_path__ + "img/rule-pic.6119ad15.png";